// extracted by mini-css-extract-plugin
export default {"your_rd":"Xx","title":"Yx","subtitle":"Zx","rd_bio_wrapper":"ay","rd_text_mobile":"by","rd_bio":"cy","img":"ey","rd_info":"fy","rd_name":"gy","rd_stat":"hy","rd_text":"iy","btn_mobile":"jy"};
    if(module.hot) {
      // 1713809678036
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  